import React from 'react';
import './OrderTable.css';

interface Order {
  id: string;
  customer: string;
  restaurant: string;
  items: number;
  amount: string;
  status: 'completed' | 'preparing' | 'pending' | 'ready' | 'cancelled';
  dateTime: string;
}

interface OrderTableProps {
  orders: Order[];
  selectedOrders: string[];
  onSelectOrder: (orderId: string) => void;
  onSelectAll: () => void;
}

const OrderTable: React.FC<OrderTableProps> = ({
  orders,
  selectedOrders,
  onSelectOrder,
  onSelectAll,
}) => {
  const allSelected = selectedOrders.length === orders.length && orders.length > 0;

  const getStatusClass = (status: string) => {
    return status.toLowerCase();
  };

  return (
    <div className="order-table-container">
      <table className="order-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Restaurant</th>
            <th>Items</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Date & Time</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedOrders.includes(order.id)}
                  onChange={() => onSelectOrder(order.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="order-id">{order.id}</td>
              <td className="order-customer">{order.customer}</td>
              <td className="order-restaurant">{order.restaurant}</td>
              <td className="order-items">{order.items} items</td>
              <td className="order-amount">{order.amount}</td>
              <td>
                <span className={`order-status status-${getStatusClass(order.status)}`}>
                  {order.status}
                </span>
              </td>
              <td className="order-datetime">{order.dateTime}</td>
              <td>
                <button className="order-actions-btn">⋯</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderTable;

